import { IconsProps } from '@/types/shared'
import React from 'react'

const SpaceDashboard: React.FC<IconsProps> = (props) => {
    return (
        <div {...props}>
            <svg
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M19 3.5H5C3.9 3.5 3 4.4 3 5.5V19.5C3 20.6 3.9 21.5 5 21.5H19C20.1 21.5 21 20.6 21 19.5V5.5C21 4.4 20.1 3.5 19 3.5ZM5 19.5V5.5H11V19.5H5ZM19 19.5H13V12.5H19V19.5ZM19 10.5H13V5.5H19V10.5Z"
                    fill="currentColor"
                />
            </svg>
        </div>
    )
}

export default SpaceDashboard
